/*
  GROOVI wipe-in observer — single IntersectionObserver targeting elements
  carrying any of the wipe utility classes. On viewport entry it adds
  .is-visible to the element (single-fire then unobserve) and the CSS
  transition completes the visual.

  Scope: only elements that opt in via the merchant-applied class (typed
  into a block's "Custom CSS class" Theme Editor field). Above-the-fold
  elements fire immediately at observer init; below-the-fold ones fire
  as scrolled into view.

  Pairs with: assets/groovi-custom.css "wipe-in animation utilities" block.
  The CSS .groovi-js gate ensures hidden initial state ONLY applies when
  JS is confirmed running — without JS, content renders normally so the
  page is never broken by a missing animation.

  No fallback timer needed: if IntersectionObserver is unavailable, we
  reveal everything at init so content is never left invisible.
*/
(function () {
  'use strict';

  var SELECTOR = '.groovi-wipe, .groovi-fade-up, .groovi-blur-in, .groovi-scale-soft, .groovi-slide-in, .groovi-typewriter';
  var io = null;

  function reveal(el) {
    el.classList.add('is-visible');
  }

  // Scan (or re-scan) the document for opt-in elements and observe any not yet
  // seen. Idempotent via a data flag so shopify:section:load can call it after
  // the Theme Editor injects a new block without leaking observers. In the Theme
  // Editor (design mode) there is no scroll, so reveal immediately.
  function scan() {
    var els = document.querySelectorAll(SELECTOR);
    if (!els.length) return;

    var designMode = window.Shopify && window.Shopify.designMode;
    if (designMode || !('IntersectionObserver' in window)) {
      els.forEach(reveal);
      return;
    }

    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.15,
        rootMargin: '0px 0px -40px 0px'
      });
    }

    els.forEach(function (el) {
      if (el.dataset.grooviWipeSeen) return;
      el.dataset.grooviWipeSeen = '1';
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // Re-scan when the Theme Editor re-renders / adds a section or block.
  document.addEventListener('shopify:section:load', scan);
}());
